import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { firebaseAuth } from '@mp';
import { GraphQLClient, RequestDocument } from 'graphql-request';

const REACT_APP_COMMIT_SHA = process.env.REACT_APP_COMMIT_SHA;

const gqlRequest = async <T = any>(query: RequestDocument | TypedDocumentNode, variables = {}) => {
  const token = await firebaseAuth.currentUser?.getIdToken();
  const client = new GraphQLClient(
    `${process.env.REACT_APP_GRAPHQL_URL || process.env.EXPO_PUBLIC_GRAPHQL_URL}/graphql`,
    {
      headers: {
        ...(token ? { authorization: `Bearer ${token}` } : {}),
        frontend_version: REACT_APP_COMMIT_SHA ?? 'unknown',
      },
      requestMiddleware: (request) => {
        const pathname = typeof window !== 'undefined' ? window?.location?.pathname : undefined;
        const search = typeof window !== 'undefined' ? window?.location?.search : undefined;

        const pathWithSearch = `${pathname}${search}`;

        return {
          ...request,
          body: JSON.stringify({
            ...JSON.parse(request.body as string),
            ...(pathWithSearch && { extensions: { pathname: pathWithSearch } }),
          }),
        };
      },
    },
  );

  return client.request<T>(query, variables);
};

export default gqlRequest;
